import { Project } from '../types';

export const projects: {
  portfolio: Project[];
  fun: Project[];
} = {
  portfolio: [
    {
      name: 'Brutal Sweden',
      link: 'https://vimeo.com/422509201',
      imageName: 'brutal_sweden.jpg',
      tags: ['2d']
    },
    {
      name: 'Nintendo Switch Colors',
      link: 'https://vimeo.com/426574034',
      imageName: 'nintendo_switch_colors.jpg',
      tags: ['3d']
    },
    // {
    //   name: 'Woodman Barbershop',
    //   link: 'https://vimeo.com/233327925',
    //   imageName: 'woodman_barbershop.jpg',
    //   tags: ['video']
    // },
    {
      name: 'Super Bawl Party',
      link: 'https://vimeo.com/322482382',
      imageName: 'super_bawl_party.jpg',
      tags: ['3d']
    },
    {
      name: 'A Tale of Two Steves',
      link: 'https://vimeo.com/360505121',
      imageName: 'tale_of_two_steaves.jpg',
      tags: ['2d']
    },
    {
      name: 'A Tale of Two Steves 2',
      link: 'https://vimeo.com/372305831',
      imageName: 'tale_of_two_steaves_2.jpg',
      tags: ['2d']
    },
    {
      name: 'Lvl Up!',
      link: 'https://vimeo.com/466527196',
      imageName: 'lvl_up.jpg',
      tags: ['short']
    },
    {
      name: 'Stolentiq Studio Logo',
      link: 'https://vimeo.com/356151200',
      imageName: 'stolentiq_studio.jpg',
      tags: ['short', '2d']
    },
    {
      name: 'Startup Village',
      link: 'https://vimeo.com/216978694',
      imageName: 'startup_village.jpg',
      tags: []
    },
    {
      name: 'Supersila',
      link: 'https://vimeo.com/233644803',
      imageName: 'supersila.jpg',
      tags: ['short']
    },
    {
      name: 'Dostaviasta',
      link: 'https://vimeo.com/382767247',
      imageName: 'dostaviasta.jpg',
      tags: ['2d']
    },
    // {
    //   name: 'Skovoroda',
    //   link: 'https://vimeo.com/226175013',
    //   imageName: 'skovoroda.jpg',
    //   tags: ['video']
    // },
    {
      name: 'Project 33',
      link: 'https://vimeo.com/214732794',
      imageName: 'project_33.jpg',
      tags: ['2d', '3d']
    },
    {
      name: 'Mediamir',
      link: 'https://vimeo.com/173634413',
      imageName: 'mediamir.jpg',
      tags: ['video']
    },
    {
      name: 'Carpe Diem Solutions',
      link: 'https://vimeo.com/370470821',
      imageName: 'carpe_diem_solutions.jpg',
      tags: ['3d']
    },
    {
      name: 'Frank Casino 2: Reservoir Boogaloo',
      link: 'https://vimeo.com/321203654',
      imageName: 'frank_casino_2.jpg',
      tags: ['2d']
    },
    {
      name: 'Frank Casino 3: ACME Drift',
      link: 'https://vimeo.com/325858073',
      imageName: 'frank_casino_3.jpg',
      tags: ['2d']
    },
    {
      name: 'Frank Casino IV: Return of the FLY',
      link: 'https://vimeo.com/330825121',
      imageName: 'frank_casino_4.jpg',
      tags: ['2d']
    },
    {
      name: 'Frank Casino 5: The Final Chapter',
      link: 'https://vimeo.com/336033364',
      imageName: 'frank_casino_5.jpg',
      tags: ['2d']
    },
    // {
    //   name: 'Phoenix Logo',
    //   link: 'https://vimeo.com/229707569',
    //   imageName: 'pheonix_logo.jpg',
    //   tags: ['short']
    // },
    // {
    //   name: 'Breakfast',
    //   link: 'https://vimeo.com/228265561',
    //   imageName: 'breakfast.jpg',
    //   tags: ['video']
    // }
  ],
  fun: [
    {
      name: 'Stolen Forest x Mizontiq - vice shiiiieeeeet',
      link:
        'https://www.youtube.com/watch?v=6ihE4AMVVDA&ab_channel=StolenForest',
      imageName: 'stolen_forest_mizontiq.jpg',
      tags: ['music video', 'track', 'chill']
    },
    {
      name: 'Stolen Forest - neprost (2018)',
      link:
        'https://soundcloud.com/stolen-forest/sets/stolen-forest-neprost-2018',
      imageName: 'stolen_forest_neprost.jpg',
      tags: ['music', 'album', 'ambient', 'electronic']
    },
    {
      name: 'Stolentiq - Guacamole Glaucoma (2017)',
      link:
        'https://soundcloud.com/stolen-forest/sets/stolentiq-guacamole-glaucoma-2017',
      imageName: 'stolentiq_guacamole.jpg',
      tags: ['music', 'album', 'collab', 'ambient', 'dark', 'trip-hop']
    },
    {
      name: 'Stolen Forest x Denysova - Humility (ft. Mizontiq)',
      link:
        'https://soundcloud.com/stolen-forest/stolen-forest-x-denysova-humility',
      imageName: 'stolen_forest_denysova.jpg',
      tags: ['music', 'track', 'collab', 'trip-hop', 'ambient', 'techno']
    },
    {
      name: 'Stolen Forest - Ptibra',
      link: 'https://soundcloud.com/stolen-forest/ptibra',
      imageName: 'stolen_forest_ptibra.jpg',
      tags: ['music', 'track', 'beats', 'chill', 'lo-fi']
    },
    {
      name: 'Stolen Forest - Quite Etique (ft. Mizontiq) (teaser)',
      link: 'https://www.instagram.com/p/CAIVmBinKxZ/',
      imageName: 'stolen_forest_quite_etique.jpg',
      tags: ['teaser', 'promo', 'sound fx']
    },
    {
      name: 'Salvation Cemetery (ft. SPACEINVADER)',
      link:
        'https://soundcloud.com/stolen-forest/salvation-cemetery-ft-spaceinvader',
      imageName: 'salvation_cementry.jpg',
      tags: ['music', 'track', 'collab', 'synthwave', 'retrowave']
    },
    {
      name: 'Stolen Forest - prost (2014)',
      link: 'https://stolenforest.bandcamp.com/album/prost',
      imageName: 'stolen_forest_prost.jpg',
      tags: ['music', 'album', 'bedroomtapes', 'ambient']
    }
  ]
};